import type { OrchestrationThreadBlock } from "@t3tools/contracts";
import { Trans } from "@lingui/react/macro";
import { memo, useState } from "react";

import { Button } from "../ui/button";
import {
  Dialog,
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPopup,
  DialogTitle,
} from "../ui/dialog";

export const ThreadBlockedNotice = memo(function ThreadBlockedNotice(props: {
  block: OrchestrationThreadBlock;
}) {
  const [reasonOpen, setReasonOpen] = useState(false);
  return (
    <div
      className="mx-auto flex w-full max-w-3xl justify-center py-3 text-sm text-muted-foreground"
      data-thread-blocked="true"
    >
      <p>
        <Trans>
          Chat blocked.{" "}
          <button
            type="button"
            className="cursor-pointer underline underline-offset-2 hover:text-foreground"
            onClick={() => setReasonOpen(true)}
          >
            Reason
          </button>
          .
        </Trans>
      </p>
      <Dialog open={reasonOpen} onOpenChange={setReasonOpen}>
        <DialogPopup className="max-w-md">
          <DialogHeader>
            <DialogTitle>{props.block.title}</DialogTitle>
            <DialogDescription>{props.block.text}</DialogDescription>
          </DialogHeader>
          <DialogFooter variant="bare">
            <DialogClose render={<Button variant="outline" />}>
              <Trans>Close</Trans>
            </DialogClose>
          </DialogFooter>
        </DialogPopup>
      </Dialog>
    </div>
  );
});
